import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-8" data-id="element-178" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-179" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-180" data-mp="3fxuni758astw">
          What appliance technicians <span className="text-electric" data-id="element-181" data-mp="3ayhz3hypldp7">are saying</span>
        </h2>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-182" data-mp="36zr35e5zc23o">
          {testimonials.map((testimonial, i) => <article key={testimonial.name} className={`flex flex-col rounded-lg border border-steel bg-white p-3.5 shadow-sm sm:p-4 ${i === 0 ? 'border-l-4 border-l-electric md:col-span-2' : ''}`} data-id="element-183" data-mp="31yl5d1xgpona" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-184" data-mp="v8dn3qgaqkei">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-amber-400" fill="currentColor" strokeWidth={0} aria-hidden="true" data-id="element-185" data-mp="q891xn4g11hy" />)}
              </div>
              <p className="mt-1.5 text-sm leading-snug text-graphite sm:text-[15px]" data-id="element-186" data-mp="79lelfp8wx8c">
                “{testimonial.quote}”
              </p>
              <div className="mt-auto flex items-center gap-3 pt-2.5" data-id="element-187" data-mp="zwppu2exm7sk">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-extrabold text-white" aria-hidden="true" data-id="element-188" data-mp="zyiu5b22ofxe">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-189" data-mp="v3mqterdy64z">
                  <p className="font-display text-sm font-extrabold uppercase leading-none text-navy" data-id="element-190" data-mp="1iva9j9ehuaw6">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="mt-1 text-xs font-semibold text-muted" data-id="element-191" data-mp="1nnv4ie94yu1a">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}